import { development } from "./environment.dev";
import { production } from "./environment.prod";
import { staging } from "./environment.staging";

type Environment = typeof production | typeof development | typeof staging;

const environments: Record<string, Environment> = {
  staging,
  production,
  development,
};
export const environment = environments[import.meta.env.MODE || "staging"];
